'use strict';

var templates = require('../templates');
var fobclient = require('..');
var PreisBezeichnung = require('../entity').PreisBezeichnung;

module.exports = function (connection) {
  return {
    byBeschreibungEquals: function byBeschreibungEquals(beschreibung, additionalParams) {
      return templates.searchTemplate(connection)(PreisBezeichnung, 'byBeschreibungEquals', 'beschreibung')(beschreibung, additionalParams);
    },
    byBeschreibungLike: function byBeschreibungLike(beschreibung, additionalParams) {
      return templates.searchTemplate(connection)(PreisBezeichnung, 'byBeschreibungLike', 'beschreibung')(beschreibung, additionalParams);
    },
    byNameEquals: function byNameEquals(name, additionalParams) {
      return templates.searchTemplate(connection)(PreisBezeichnung, 'byNameEquals', 'name')(name, additionalParams);
    },
    byNameLike: function byNameLike(name, additionalParams) {
      return templates.searchTemplate(connection)(PreisBezeichnung, 'byNameLike', 'name')(name, additionalParams);
    },
    bySearchRepLike: function bySearchRepLike(rep, additionalParams) {
      return templates.searchTemplate(connection)(PreisBezeichnung, 'bySearchRepLike', 'rep')(rep, additionalParams);
    },
    withGenericAnd: function withGenericAnd(searchParams) {
      return templates.genericSearchTemplate(connection)(PreisBezeichnung, 'genericand')(searchParams);
    },
    byID: function byID(_id) {
      return fobclient.genericGet('preisbezeichnung')(_id);
    }
  };
};


//////////////////
// WEBPACK FOOTER
// ./~/fobclient/lib/find/preisBezeichnung.js
// module id = L5u7
// module chunks = 0